import actions from "./actions"

export default function vehicleConfigurationReducers(state = [], action: {payload: any, type: string}):any{
    switch (action.type){
        case actions.SET_VEHICLE_CONFIGURATION:
            return action.payload;
        default:
            return state
    }
}

